import { AlertIcon, Typography } from '@iheartjane/reefer';

import styles from './storeSwitcherError.module.css';

export const StoreSwitcherError = ({ error }: { error: string }) => (
  <div className={styles['errorContainer']}>
    <AlertIcon className={styles['errorIcon']} />
    <Typography
      ml={16}
      variant="small-body-semibold"
      className={styles['errorText']}
    >
      {error}
    </Typography>
  </div>
);
